import React from 'react';
import { connect } from 'react-redux';
import pt from 'prop-types';

import {
  StorefrontNavigation,
  mapStateToProps,
  mapDispatchToProps,
} from 'containers/StorefrontNavigation';
import NewMenuModalPage from 'components/pages/modals/new-menu';

class NewMenuModal extends StorefrontNavigation {
  static contextTypes = {
    notifyCreated: pt.func.isRequired,
    notifyError: pt.func.isRequired,
    closeModal: pt.func.isRequired,
  };

  state = {
    edited: false,
  };

  onSave = (values) => {
    return super.onSaveMenu(values);
  };

  onEdited = (edited) => {
    this.setState({ edited });
  };

  render() {
    return (
      <NewMenuModalPage
        {...this.props}
        {...this.state}
        onSave={this.onSave}
        onEdited={this.onEdited}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewMenuModal);
